import React from "react";
import i18n from "i18next";
import Users from './views/Users';
import Promos from './views/Promos';
import Panics from "views/Panics.js";
import AboutUs from "./views/AboutUs";
import Banners from "views/Banners.js";
import { Provider } from "react-redux";
import AddMoney from "./views/AddMoney";
import CarsList from "./views/CarsList";
import CarTypes from './views/CarTypes';
import Withdraws from './views/Withdraws';
import ContactUs from "./views/ContactUs";
import Dashboard from './views/Dashboard';
import MyProfile from './views/MyProfile';
import Settings from './views/Settings.js';
import UserWallet from "./views/UserWallet";
import AllReports from "./views/AllReports";
import LoginPage from "./views/LoginPage.js";
import AddBookings from './views/AddBookings';
import AuthLoading from './views/AuthLoading';
import Notifications from './views/Notifications';
import MuiTheme from "components/Theme/muiTheme";
import { initReactI18next } from "react-i18next";
import { FirebaseProvider, store } from "common";
import TermCondition from "views/TermCondition.js";
import ProtectedRoute from './views/ProtectedRoute';
import BookingHistory from './views/BookingHistory';
import { HelmetProvider } from "react-helmet-async";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import EmailValidation from "views/EmailValidation";
import { ThemeProvider } from '@mui/material/styles';
import { useJsApiLoader } from '@react-google-maps/api';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CancellationReasons from './views/CancellationReasons';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import RequestAccountDeletion from "views/RequestAccountDeletion.js";
import { CssBaseline, GlobalStyles } from "@mui/material";


const libraries = ['geometry', 'drawing', 'places'];


i18n
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false
    }
  });

function App() {

  useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  })


  const config = {
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  }




  return (
    <HelmetProvider>
      <Provider store={store}>
        <FirebaseProvider config={config}>
          <GoogleOAuthProvider clientId={process.env.WEB_CLIENT_ID}>
            <ThemeProvider theme={MuiTheme}>
              <CssBaseline />
              <GlobalStyles />
              <AuthLoading>
                <BrowserRouter>
                  <Routes>
                    <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"}><Dashboard /></ProtectedRoute>} />
                    <Route path="/bookings" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><BookingHistory /></ProtectedRoute>} />
                    <Route path="/profile" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><MyProfile /></ProtectedRoute>} />
                    <Route path="/cartypes" element={<ProtectedRoute permit={"admin"}><CarTypes /></ProtectedRoute>} />
                    <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><CarsList /></ProtectedRoute>} />
                    <Route path="/cancelreasons" element={<ProtectedRoute permit={"admin"}><CancellationReasons /></ProtectedRoute>} />
                    <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin"}><AddBookings /></ProtectedRoute>} />
                    <Route path="/promos" element={<ProtectedRoute permit={"admin"}><Promos /></ProtectedRoute>} />
                    <Route path="/users" element={<ProtectedRoute permit={"admin,fleetadmin"}><Users /></ProtectedRoute>} />
                    <Route path="/notifications" element={<ProtectedRoute permit={"admin"}><Notifications /></ProtectedRoute>} />
                    <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"}><AddMoney /></ProtectedRoute>} />
                    <Route path="/userwallet" element={<ProtectedRoute permit={"customer,driver"}><UserWallet /></ProtectedRoute>} />
                    <Route path="/withdraws" element={<ProtectedRoute permit={"admin"}><Withdraws /></ProtectedRoute>} />
                    <Route path="/panics" element={<ProtectedRoute permit={"admin"}><Panics /></ProtectedRoute>} />
                    <Route path="/allreports" element={<ProtectedRoute permit={"admin,fleetadmin"}><AllReports /></ProtectedRoute>} />
                    {/* <Route path="/banners" element={<ProtectedRoute permit={"admin"}><Banners /></ProtectedRoute>} /> */}
                    <Route path="/settings" element={<ProtectedRoute permit={"admin"}><Settings /></ProtectedRoute>} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/email-Validation" element={<EmailValidation />} />
                    <Route path="/request-account-deletion" element={<RequestAccountDeletion />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/term-condition" element={<TermCondition />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/" element={<LoginPage />} />
                  </Routes>
                </BrowserRouter>
              </AuthLoading>
            </ThemeProvider>
          </GoogleOAuthProvider>
        </FirebaseProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;